import React from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const EmbeddedDialog = (props) => {
  const { title, children, actions } = props
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <section className={classes.dialog}>
          <header className={classes.header}>{title}</header>
          <div className={classes.content}>{ children }</div>
          <footer className={classes.footer}>{actions}</footer>
        </section>
      </div>
    </div>
  )
}

EmbeddedDialog.propTypes = {
  title: PropTypes.string.isRequired,
  actions: PropTypes.array,
  children: PropTypes.node,
  classes: PropTypes.object,
}

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: 1,
    background: 'rgba(255,255,255, .9)',

  },
  container: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialog: {
    borderRadius: '4px',
    background: '#fff',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
    border: '1px solid #eee',
    maxWidth: '90%',
  },
  header: {
    display: 'flex',
    padding: '32px 32px 0px 32px',
    fontSize: '24px',
  },
  footer: {
    padding: '20px 32px',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
  },
  content: {
    padding: '0px 32px',
  },
}))

export default EmbeddedDialog
